var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "28px",
    viewBox: "0 0 50 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-fuel-tank-filled",
    transform: "translate(-1.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04853877,0 C0.596498843,0 1,3.04087145 1,3.59555845 L1,18.0239955 C1,18.5906885 1.449219,19 2,19 L3.65827299,19 C2.86921099,19.953125 2.39264799,21.171875 2.39264799,22.5 C2.39264799,25.527344 4.86530399,28 7.89264799,28 C10.404367,28 12.533273,26.289063 13.185617,23.980469 C13.2298877,23.983073 19.5729633,23.9895833 32.214844,24 C32.871094,26.300781 34.996094,28 37.5,28 C40.003906,28 42.128906,26.300781 42.785156,24 L50,24 C50.550781,24 51,23.550781 51,23 L51,10.0625 C51,9.148438 50.679688,8.253906 50.105469,7.542969 L45.175781,1.480469 C44.414063,0.539063 43.28125,0 42.074219,0 L36,0 C34.347656,0 33,1.347656 33,3 L33,17 L31,17 L31,2 C31,0.898438 30.101563,0 29,0 L5.04853877,0 Z M40,5 L45.464844,5 L48.550781,8.804688 C48.839844,9.160156 49,9.605469 49,10.0625 L49,11 L40,11 C39.449219,11 39,10.550781 39,10 L39,6 C39,5.449219 39.449219,5 40,5 Z M16.5,6 C16.5,6 19,9.117188 19,10.5 C19,11.882813 17.882813,13 16.5,13 C15.117188,13 14,11.882813 14,10.5 C14,9.117188 16.5,6 16.5,6 Z M8,19 C9.945313,19 11.5,20.554688 11.5,22.5 C11.5,24.445313 9.945313,26 8,26 C6.054688,26 4.5,24.445313 4.5,22.5 C4.5,20.554688 6.054688,19 8,19 Z M11.844376,19 L33.265625,19 C32.578125,19.832031 32.128906,20.867188 32.027344,22 L13.082657,22 C12.981095,20.867188 12.531876,19.832031 11.844376,19 Z M37.5,19 C39.445313,19 41,20.554688 41,22.5 C41,24.445313 39.445313,26 37.5,26 C35.554688,26 34,24.445313 34,22.5 C34,20.554688 35.554688,19 37.5,19 Z M41.734375,19 L49,19 L49,22 L42.972656,22 C42.871094,20.867188 42.421875,19.832031 41.734375,19 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.7b7a2f8f3b6619266ceedc63aeac923d.svg";
export { ForwardRef as ReactComponent };